// extracted by mini-css-extract-plugin
export default {"deleteButton":"styles_deleteButton__nOHOO","linearProgress":"styles_linearProgress__CUuQK"};